import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../Shared/Hooks/useTheme";

export const ThemeToggle = () => {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center border-0"
      title={theme === "dark" ? t("Modo claro") : t("Modo oscuro")}
      style={{
        width: "36px",
        height: "36px",
        cursor: "pointer",
        fontSize: "1.1rem",
        color: "var(--tws-dark)",
      }}
      aria-label={t("Cambiar tema")}
    >
      {theme === "dark" ? "\u2600" : "\u263E"}
    </button>
  );
};
